(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alh-card-text-policy"] && !Shopify.designMode) return;
  try {
    function initAlhCardTextPolicy(root) {
    if (root.dataset.initialized === 'true') return;
    const form = root.closest('form');
    if (!form) return;
    root.dataset.initialized = 'true';
    const eligibility = JSON.parse(root.textContent);
    const variantInput = form.querySelector('.product-variant');

    function syncCardText() {
      const allowed = Boolean(variantInput && eligibility[variantInput.value] === true);
      form.querySelectorAll('.upload-container .cl-upload--input[name="properties[text]"]').forEach((input) => {
        const field = input.closest('.cl-upload--input-field');
        if (!field) return;
        if (!allowed) {
          if (!input.hasAttribute('data-alh-card-text-blocked')) {
            input.dataset.alhCardTextBlocked = '';
            input.dataset.alhCardTextWasDisabled = String(input.disabled);
            input.dataset.alhCardTextWasRequired = String(input.required);
          }
          if (!input.disabled) input.disabled = true;
          if (input.required) input.required = false;
          if (!field.hasAttribute('data-alh-card-text-hidden')) field.setAttribute('data-alh-card-text-hidden', '');
        } else if (input.hasAttribute('data-alh-card-text-blocked')) {
          input.disabled = input.dataset.alhCardTextWasDisabled === 'true';
          input.required = input.dataset.alhCardTextWasRequired === 'true';
          delete input.dataset.alhCardTextBlocked;
          delete input.dataset.alhCardTextWasDisabled;
          delete input.dataset.alhCardTextWasRequired;
          field.removeAttribute('data-alh-card-text-hidden');
        }
      });
    }

    form.addEventListener('change', () => requestAnimationFrame(syncCardText));
    form.addEventListener('submit', syncCardText, true);
    const observer = new MutationObserver(syncCardText);
    observer.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled', 'required'] });
    syncCardText();
  }

  function initAllAlhCardTextPolicies() {
    document.querySelectorAll('[data-alh-card-text-policy]').forEach(initAlhCardTextPolicy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllAlhCardTextPolicies, { once: true });
  } else {
    initAllAlhCardTextPolicies();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alh-shineon-custom-fields"] && !Shopify.designMode) return;
  try {
    function initAlhShineOnFields(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const form = root.closest('form');
    if (!form) return;
    const variantInput = form.querySelector('.product-variant');
    const groups = Array.from(root.querySelectorAll('[data-alh-shineon-variant]'));
    const savedValues = new Map();

    function sync() {
      const selectedId = variantInput ? variantInput.value : '';
      const appInput = form.querySelector('.upload-container .cl-upload--input[name="properties[text]"]');
      const upload = appInput && appInput.closest('.upload-container');
      if (upload && (upload.parentElement !== form || upload.previousElementSibling !== root)) {
        root.after(upload);
      }

      groups.forEach((group) => {
        const active = group.dataset.alhShineonVariant === selectedId;
        const beadCount = Number(group.dataset.alhShineonBeadCount) || 0;
        group.hidden = !active;
        group.querySelectorAll('[data-alh-shineon-static]').forEach((input) => { input.disabled = !active; });
        group.querySelectorAll('[data-alh-shineon-property]').forEach((input) => {
          if (active && savedValues.has(input.dataset.alhShineonProperty) && !input.value) {
            input.value = savedValues.get(input.dataset.alhShineonProperty);
          }
          const field = input.closest('.alh-shineon-fields__field');
          const appHandlesField = Boolean(appInput && field.hasAttribute('data-alh-shineon-hyper'));
          const beadIndex = Number(field.dataset.alhShineonBeadIndex) || 0;
          const extraBead = beadCount > 0 && beadIndex > beadCount;
          field.hidden = appHandlesField || extraBead;
          input.disabled = !active || appHandlesField || extraBead;
          input.required = active && !appHandlesField && !extraBead && (input.hasAttribute('data-alh-required') || beadIndex > 0);
        });
        const grid = group.querySelector('.alh-shineon-fields__grid');
        if (grid) {
          grid.classList.toggle('alh-shineon-fields__grid--single', group.querySelectorAll('.alh-shineon-fields__field:not([hidden])').length === 1);
        }
      });

      let mirror = form.querySelector('[data-alh-shineon-cloudlift-mirror]');
      if (appInput && groups.some((group) => group.dataset.alhShineonVariant === selectedId && group.querySelector('[data-alh-shineon-hyper]'))) {
        if (!mirror) {
          mirror = document.createElement('input');
          mirror.type = 'hidden';
          mirror.name = 'properties[Hyper Text Component]';
          mirror.dataset.alhShineonCloudliftMirror = '';
          form.append(mirror);
        }
        mirror.value = appInput.value;
        mirror.disabled = false;
      } else if (mirror) {
        mirror.disabled = true;
      }
      root.hidden = !groups.some((group) => !group.hidden && group.querySelector('.alh-shineon-fields__field:not([hidden])'));
    }

    root.addEventListener('input', (event) => {
      if (event.target.matches('[data-alh-shineon-property]')) {
        savedValues.set(event.target.dataset.alhShineonProperty, event.target.value);
      }
    });
    form.addEventListener('change', (event) => {
      if (event.target.closest('[data-product-options]')) requestAnimationFrame(sync);
    });
    form.addEventListener('input', (event) => {
      if (event.target.matches('.cl-upload--input[name="properties[text]"]')) sync();
    });
    form.addEventListener('submit', sync, true);
    const observer = new MutationObserver(() => sync());
    observer.observe(form, { childList: true, subtree: true });
    sync();
  }

  function initAllAlhShineOnFields() {
    document.querySelectorAll('[data-alh-shineon-fields]').forEach(initAlhShineOnFields);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllAlhShineOnFields, { once: true });
  } else {
    initAllAlhShineOnFields();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeStickyCart = () => {
      document.querySelectorAll('[data-alh-sticky-cart]').forEach((stickyCart) => {
        if (stickyCart.dataset.alhStickyReady === 'true') return;

        const productForm = document.querySelector('.product-form');
        const mainButton = productForm?.querySelector('.product-button[type="submit"]');
        const mainButtonText = mainButton?.querySelector('.product-button__text');
        const variantInput = productForm?.querySelector('[name="id"]');
        const stickyButton = stickyCart.querySelector('[data-alh-sticky-add-to-cart]');
        const stickyButtonText = stickyCart.querySelector('[data-alh-sticky-button-text]');
        const stickyButtonArrow = stickyCart.querySelector('[data-alh-sticky-button-arrow]');
        const stickySelection = stickyCart.querySelector('[data-alh-sticky-selection]');
        const stickyPrice = stickyCart.querySelector('[data-alh-sticky-price]');
        const stickyComparePrice = stickyCart.querySelector('[data-alh-sticky-compare-price]');
        const productContainer = productForm?.closest('[data-product-container]');
        const sourcePrice = productContainer?.querySelector('.product-prices .product-price');
        const sourceComparePrice = productContainer?.querySelector('.product-prices .product-compare-price');
        const formId = productForm?.getAttribute('id') || '';
        const productJsonId = formId.replace('ProductForm-', 'ProductJson-');
        const productJson = document.getElementById(productJsonId);

        if (!productForm || !mainButton || !variantInput || !stickyButton || !stickyButtonText) return;

        let productData = null;

        try {
          productData = productJson ? JSON.parse(productJson.textContent) : null;
        } catch (_error) {
          productData = null;
        }

        const syncStickyCart = () => {
          const variant = productData?.variants?.find((item) => String(item.id) === String(variantInput.value));
          const buttonLabel = mainButtonText?.textContent.trim() || (
            variant
              ? (variant.available ? stickyCart.dataset.addLabel : stickyCart.dataset.soldOutLabel)
              : stickyCart.dataset.unavailableLabel
          );

          stickyButtonText.textContent = buttonLabel;
          stickyButton.disabled = mainButton.disabled || !variant || !variant.available;

          if (stickyButtonArrow) {
            stickyButtonArrow.hidden = stickyButton.disabled;
          }

          if (stickySelection) {
            const selectionText = variant?.title && variant.title !== 'Default Title' ? variant.title : '';
            stickySelection.textContent = selectionText;
            stickySelection.hidden = selectionText.length === 0;
          }

          if (stickyPrice && sourcePrice) {
            stickyPrice.textContent = sourcePrice.textContent.trim();
          }

          if (stickyComparePrice && sourceComparePrice) {
            const compareText = sourceComparePrice.textContent.trim();
            stickyComparePrice.textContent = compareText;
            stickyComparePrice.hidden = compareText.length === 0;
          }
        };

        stickyButton.addEventListener('click', () => {
          if (stickyButton.disabled) return;

          if (!productForm.checkValidity()) {
            const invalidField = productForm.querySelector(':invalid');
            invalidField?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            productForm.reportValidity();
            return;
          }

          if (typeof productForm.requestSubmit === 'function') {
            productForm.requestSubmit(mainButton);
          } else {
            mainButton.click();
          }
        });

        productForm.addEventListener('change', () => requestAnimationFrame(syncStickyCart));
        document.addEventListener('product:form:loaded', () => requestAnimationFrame(syncStickyCart));

        const buttonObserver = new MutationObserver(syncStickyCart);
        buttonObserver.observe(mainButton, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });

        stickyCart.dataset.alhStickyReady = 'true';
        syncStickyCart();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeStickyCart, { once: true });
    } else {
      initializeStickyCart();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
